module.exports = __webpack_public_path__ + "img/mapbg.e8ff1d99.png";